export const getTicketsList = "/admin/v1/viewAllTickets"
export const assignTicket = "/admin/v1/assignTicket"
export const resolveTicket = "/admin/v1/resolveTicket"
export const joinTicketRoom = "/admin/v1/joinTicketRoom"
export const getCustomerProfile = "/admin/v1/getTicketUserProfile"
//============= Ticket Analytics Page ================
export const getTicketStats = "/admin/v1/ticketsAnalytics/getTicketsStates"
export const getResolvedTicketsData = "/admin/v1/ticketsAnalytics/getTicketChartData"
